define('rebrush/components/compare/compare',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'cartware/components/Dispatcher',
    'json!rebrush/handles/default.json',
    'gigaset/spinner',
    'text!shoptheme/templates/magnific-popup/default.html',
    'magnific-popup'
], function (
    $,
    _,
    Component,
    BEM,
    ComponentDispatcher,
    Handles,
    Spinner,
    PopupHtml
) {
    var popupTemplate = null,
        $document = $(document.body),
        MODIFIER_ROTATE = 'rotate',
        STATE_ACTIVE = 'active',
        STATE_INACTIVE = 'inactive';

    return Component.create({
        overlay: null,
        compareList: null,
        compareListHeaderSidebar: null,
        compareListHeaderItem: null,
        compareListFooter: null,
        productChooser: null,
        modalMainClasses: null,
        isFilteredView: false,
        localStorage: window.localStorage,
        compareTriggerClass: BEM.buildElementClassname('product-item', 'compare-trigger'),
        isCheckoutPage: gigaset.handles && gigaset.handles.includes('checkout-onepage-index') || false,
        isCategoryPage: gigaset.handles && gigaset.handles.includes('catalog_category_view') || false,
        isProductPage: gigaset.handles && gigaset.handles.includes('catalog_product_view') || false,
        isComparisonPage: gigaset.handles && gigaset.handles.includes('catalog_product_compare_list') || false,
        storeCode: gigaset.store_code,
        stickyRowOffsetTop: null,
        config: {
            storage: {
                identifier: 'compare_data',
                key_whitelist: ['item_count', 'product_ids', 'attribute_set', 'attribute_set_name', 'filter_attributes', 'is_filtered_view']
            },
            maxItemCount: gigaset.cartware_compare.config.max_item_count || 8
        },

        $init: function () {
            this._initData();
            this.initializeEvents();
        },

        _initData: function () {
            var productIds = this.getLocalStorageData('product_ids') || null;

            if (this.isComparisonPage) {
                this.initializeCompareList();
            } else {
                if (productIds) {
                    this.triggerCompareTriggerState();
                    this.triggerCompareLinkState();
                }
                this.toggleOverlay();
            }
        },

        initializeEvents: function () {
            $document.on('click', '.compare-link', _.bind(this.onClickCompareLink, this));
            $(document).on('product/changeSimple', $.proxy(this.onConfigurableSimpleChange, this));
            $document.on('click', '.' + this.compareTriggerClass, _.bind(this.onClickCompareTrigger, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-overlay', 'reset-button'), _.bind(this.onClickResetButton, this));
        },

        initializeCompareList: function () {
            this.compareList = BEM.block('compare-list');
            this.compareListHeaderSidebar = BEM.block('compare-list-header-sidebar');
            this.compareListHeaderItem = BEM.block('compare-list-header-item');
            this.compareListFooter = BEM.block('compare-list-footer');

            $document.on('click', '.' + BEM.buildElementClassname('compare-list-header-sidebar', 'cta-product-chooser'), _.bind(this.onClickProductChooserButton, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list-header-sidebar', 'cta-share'), _.bind(this.onClickShareButton, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list-header-sidebar', 'cta-list-reset'), _.bind(this.onClickResetButton, this));
            $document.on('change', '.' + BEM.buildElementClassname('compare-list-header-sidebar', 'radio-view'), _.bind(this.onChangeRadioView, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list-header-item', 'remove-button'), _.bind(this.onClickRemoveButton, this));
            $document.on('click', 'tr.' + BEM.buildElementClassname('compare-list', 'row-attributes-parent'), _.bind(this.onAttributeParentSectionTrigger, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list', 'checkbox-filter'), _.bind(this.onClickCheckboxFilter, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list', 'cta-close'), _.bind(this.onClickCloseButton, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-list-footer', 'cta-top'), _.bind(this.onOverlayBackToTop, this));

            this.initWrapperSideScrollEvents();
            this.initWrapperDownScrollEvents();

            this.initLocalStorage();
            this.restoreFilterStates();
        },

        initializeProductChooser: function () {
            this.productChooser = BEM.block('compare-product-chooser');
            this.itemCountBeforeChooser = this.getLocalStorageData('item_count');

            var self = this;

            $document.on('click', '.' + BEM.buildElementClassname('compare-product-chooser', 'cta-close'), _.bind(this.onClickCloseButton, this));
            $document.on('click', '.' + BEM.buildElementClassname('compare-product-chooser', 'cta-submit'), _.bind(this.onClickCloseButton, this));

            this.productChooser.getElements('cta-item-add').each(function (i, e) {
                e.on('click', _.bind(self.onClickProductChooserAddItem, self));
            });
        },

        onClickCompareTrigger: function (e) {
            var element = $(e.currentTarget),
                productType = element.data('product-type'),
                parent = element.closest('.b_product-item__container');

            e.preventDefault();
            Spinner.add(parent);

            if (productType !== 'configurable') {
                this.updateCompareList(element);
                Spinner.remove();
            } else {
                var ajaxCartUrl = element.data('ajax-cart-url');
                this.openCatalogProductViewLightbox(ajaxCartUrl);
            }
        },

        onClickCompareLink: function (e) {
            var element = $(e.currentTarget),
                parent = element.closest('.b_product-add-to-links'),
                productType = element.data('product-type'),
                notificationInput = $('#watchlist_email');

            e.preventDefault();

            if (notificationInput) {
                notificationInput.removeClass('required-entry');
                notificationInput.removeClass('validate-email');
            }

            if (this.validateProduct(productType)) {
                Spinner.add(parent);

                if (false !== this.updateCompareList(element)) {

                    if (this.isCategoryPage) {
                        this.triggerCompareTriggerState();
                        if (element.parents('.popup-body').length > 0) {
                            $.magnificPopup.close();
                        }
                    } else {
                        if (element.hasClass('active')) {
                            var msg = Translator.translate('%s added to the comparison list. Add more products ' +
                                'via the category overview or select more product variants for the comparison to compare products ' +
                                'with each other.').replace('%s', element.data('product-name'));

                            if (this.getLocalStorageData('item_count') > 1) {
                                var compareUrl = this.getCompareUrl();
                                msg += ' ' + '<a href="' + compareUrl + '" class="text-primary">' + Translator.translate('Go to comparison') + '</a>';
                            }

                            this.triggerSessionMessage(msg, 'success');
                        }
                    }
                }
                Spinner.remove();
            }

            if (notificationInput) {
                notificationInput.addClass('required-entry');
                notificationInput.addClass('validate-email');
            }
        },

        triggerCompareTriggerState: function () {
            var self = this,
                storageData = this.getLocalStorageData();

            $('.' + self.compareTriggerClass).each(function (index, item) {
                var e = $(item);
                if (storageData && storageData.product_ids) {
                    if (e.data('product-type') === 'configurable') {
                        var childIds = [];
                        var childProducts = e.attr('data-child-products');
                        if (childProducts) {
                            if (childProducts.includes(',')) {
                                childIds = childProducts.split(',');
                            } else {
                                childIds.push(childProducts);
                            }
                        }
                        if (childIds.some(id => storageData.product_ids.includes(Number(id)))) {
                            self.setElementState(e, STATE_ACTIVE);
                        } else {
                            self.setElementState(e, STATE_INACTIVE);
                        }
                    } else {
                        var productId = e.data('product');
                        if (productId && storageData.product_ids.includes(productId)) {
                            self.setElementState(e, STATE_ACTIVE);
                        } else {
                            self.setElementState(e, STATE_INACTIVE);
                        }
                    }
                } else {
                    self.setElementState(e, STATE_INACTIVE);
                }
            });
        },

        triggerCompareLinkState: function (simple) {
            var compareLink = $('.compare-link'),
                simpleId = simple && simple.id ? simple.id : null,
                storageData = this.getLocalStorageData();

            if (!simpleId) {
                if (compareLink.data('product-type') === 'configurable') {
                    var currentSimple = _.get(window, 'spConfig.__currentSimple');
                    if (currentSimple) {
                        simpleId = currentSimple.id;
                    }
                } else {
                    simpleId = compareLink.data('product');
                }
            }
            simpleId = Number(simpleId);
            if (storageData && storageData.product_ids && simpleId && storageData.product_ids.include(simpleId)) {
                this.setElementState(compareLink, STATE_ACTIVE);
            } else {
                this.setElementState(compareLink, STATE_INACTIVE);
            }
        },

        setElementState: function (e, state) {
            switch (state) {
                case STATE_ACTIVE:
                    if (!e.hasClass('active')) {
                        e.addClass('active');
                    }
                    if (e.hasClass('compare-link')) {
                        e.text(e.data('remove-text'));
                    }
                    break;
                case STATE_INACTIVE:
                    if (e.hasClass('active')) {
                        e.removeClass('active');
                    }
                    if (e.hasClass('compare-link')) {
                        e.text(e.data('add-text'));
                    }
                    break;
                default:
                    return;
            }
        },

        validateProduct: function (type) {
            if (type === 'configurable') {
                if (typeof productAddToCartForm === 'undefined' || !productAddToCartForm.validator.validate()) {
                    return false;
                }
            }
            return true;
        },

        updateCompareList: function (element) {
            let storageData = this.getLocalStorageData(),
                itemId = null;

            if (element.data('product-type') === 'configurable') {
                var configurableConfig = _.get(window, 'spConfig');
                itemId = Number(configurableConfig.__currentSimple.id);
            } else {
                itemId = Number(element.data('product'));
            }

            if (!storageData) {
                storageData = this.initCompareListStorageData(itemId, element.data('attribute-set'), element.data('attribute-set-name'));
                this.setElementState(element, STATE_ACTIVE);
            } else {
                if (storageData.product_ids.includes(itemId)) {
                    storageData = this.removeFromCompareList(itemId);
                    this.setElementState(element, STATE_INACTIVE);
                } else {
                    storageData = this.addToCompareList(itemId, element.data('attribute-set'));

                    if (!storageData) {
                        this.setElementState(element, STATE_INACTIVE);
                    } else {
                        this.setElementState(element, STATE_ACTIVE);
                    }
                }
            }

            this.toggleOverlay();

            return storageData;
        },

        addToCompareList: function (itemId, attributeSet) {
            var storageData = this.getLocalStorageData();

            if (!this.validateCompareData(storageData, attributeSet)) {
                return false;
            } else {
                storageData.item_count += 1;
                storageData.product_ids.push(itemId);
                this.updateLocalStorageData(storageData);
            }

            return storageData;
        },

        removeFromCompareList: function (itemId) {
            var storageData = this.getLocalStorageData();

            storageData.item_count -= 1;

            if (storageData.item_count <= 0) {
                this.resetLocalStorageData();
                this.resetCompareView();
                this.hideOverlay();
            } else {
                storageData.product_ids.splice(storageData.product_ids.indexOf(itemId), 1);
                this.updateLocalStorageData(storageData);
            }

            return storageData;
        },

        initCompareListStorageData: function (itemId, attributeSet, attributeSetName) {
            let configObject = {
                item_count: 1,
                product_ids: [],
                attribute_set: attributeSet,
                attribute_set_name: attributeSetName
            };
            configObject.product_ids.push(itemId);
            this.updateLocalStorageData(configObject);

            return configObject;
        },

        validateCompareData: function (storageData, attributeSet) {
            var errorMessage;

            if (storageData.attribute_set !== attributeSet) {
                errorMessage = Translator.translate('Chosen product is not matching the product type %s').replace('%s', storageData.attribute_set_name || '');
            }
            if (storageData.item_count + 1 > this.config.maxItemCount) {
                errorMessage = Translator.translate('Compare list is full (Max. %s items).').replace('%s', this.config.maxItemCount);
            }

            if (errorMessage) {
                if (this.isComparisonPage) {

                    var alertBoxClass = BEM.buildElementClassname('compare-product-chooser', 'alert-box');
                    var alertBox = $('.' + alertBoxClass);

                    alertBox.text(errorMessage).bemAddModifier('error');

                    setTimeout(function () {
                        alertBox.bemRemoveModifier('error');
                    }, 2500);
                } else {
                    this.renderMagnificPopup(errorMessage);
                }

                return false;
            }

            return true;
        },

        onConfigurableSimpleChange: function (e, simple) {
            this.triggerCompareLinkState(simple);
        },

        onClickResetButton: function (e) {
            var element = $(e.currentTarget),
                confirmation = element.data('confirmation'),
                allowClean = confirm(confirmation);

            e.preventDefault();

            if (allowClean === true) {
                this.resetLocalStorageData();
                this.resetCompareView();
                this.hideOverlay();
                if (this.isCategoryPage) {
                    this.triggerCompareTriggerState();
                }
                if (this.isProductPage) {
                    this.triggerCompareLinkState();
                }
            } else {
                e.stopPropagation();
                return false;
            }
        },

        exitLightbox: function () {
            $('.tooltip').hide();
            if ($.magnificPopup.instance.isOpen) {
                $.magnificPopup.close();
            }
            this.toggleOverlay();
            if (this.isProductPage) {
                this.triggerCompareLinkState();
            }
            if (this.isCategoryPage) {
                this.triggerCompareTriggerState();
            }
        },

        resetCompareView: function () {
            if (this.isComparisonPage) {
                BEM.block('compare-list-footer').remove();
                var compareList = BEM.block('compare-list');
                compareList.getElements('container').remove();
                compareList.getElements('no-items').bemRemoveModifier('hide');
            }
        },

        onClickRemoveButton: function (e) {
            var element = $(e.currentTarget),
                itemId = element.data('product');

            if (itemId) {
                $('.' + BEM.buildElementClassname('compare-list', 'table')).find('td[data-product="' + itemId + '"]').remove();
                this.removeFromCompareList(itemId);
                $('.tooltip').hide();
                var itemCount = this.getLocalStorageData('item_count');
                if (this.getLocalStorageData('item_count') === 0 || !itemCount) {
                    this.resetCompareView();
                }
            }

            this.refreshWindowUrl();
            this.fixStickyRowDimensions();
        },

        onClickShareButton: function (e) {
            var shareUrl = this.getCompareUrl(),
                successNotification = BEM.block('compare-list-header-sidebar').getElements('success-notification--cta-share');

            if (navigator.share) {
                navigator.share({
                    title: Translator.translate('Select your preferred share option.'),
                    url: shareUrl
                }).then(() => {
                    successNotification.fadeIn().delay(2000).fadeOut();
                });
            } else {
                navigator.permissions.query({name: 'clipboard-write'}).then((result) => {
                    if (result.state === 'granted' || result.state === 'prompt') {
                        navigator.clipboard.writeText(shareUrl).then(function () {
                            successNotification.fadeIn().delay(3000).fadeOut();
                        });
                    }
                });
            }
        },

        onClickProductChooserButton: function (e) {
          this.openProductChooserPopup();
        },

        onClickProductChooserAddItem: function (e) {
            const element = $(e.currentTarget),
                  self = this,
                  parentWrapper = element.closest('.' + BEM.buildElementClassname('compare-product-chooser', 'item-wrapper'));

            let productId = element.data('product-id'),
                success = false;

            if (element.data('product-type') === 'configurable') {
                const variantSelect = parentWrapper.find('.' + BEM.buildElementClassname('compare-product-chooser', 'item-variant-select'));
                productId = variantSelect.val();
            }

            if (self.getLocalStorageData('product_ids').includes(productId)) {
                success = self.removeFromCompareList(productId);
            } else {
                success = self.addToCompareList(productId, element.data('attribute-set-id'));
            }

            if (typeof success !== 'undefined') this.toggleProductChooserItemSelected(element);
        },

        toggleProductChooserItemSelected: function (element) {
            var icon = element.find('svg'),
                parentWrapper = element.closest('.' + BEM.buildElementClassname('compare-product-chooser', 'item-wrapper')),
                variantSelect = parentWrapper.find('.' + BEM.buildElementClassname('compare-product-chooser', 'item-variant-select'));

            if (icon) {
                icon.toggleClass('icon-rebrush-ui-check-white');
                icon.toggleClass('icon-rebrush-ui-plus-orange');
            }

            if (parentWrapper) {
                if (!parentWrapper.bemHasModifier('selected')) {
                    parentWrapper.bemAddModifier('selected');
                } else {
                    parentWrapper.bemRemoveModifier('selected');
                }
            }

            if (element) {
                if (!element.bemHasModifier('selected')) {
                    element.bemAddModifier('selected');
                } else {
                    element.bemRemoveModifier('selected');
                }
            }

            if(variantSelect) {
                if (!variantSelect.attr('disabled')) {
                    variantSelect.attr('disabled','disabled');
                } else {
                    variantSelect.removeAttr('disabled');
                }
            }
        },

        onChangeRadioView: function (e) {
            switch (e.target.value) {
                case 'view-all':
                    this.resetFilters();
                    this.isFilteredView = false;
                    break;
                case 'view-filtered':
                    this.applyFilters();
                    this.isFilteredView = true;
                    break;
                default:
                    return;
            }
        },

        resetFilters: function () {
            var compareList = BEM.block('compare-list'),
                attributeRows = compareList.getElements('row-attributes-child'),
                storageData = this.getLocalStorageData(),
                self = this;

            attributeRows.each(function (index, element) {
                self.showRow($(element));
            });

            $('.' + BEM.buildElementClassname('compare-list', 'section-trigger-icon')).each(function (index, element) {
                var triggerIcon = $(element);
                if (!triggerIcon.bemHasModifier(MODIFIER_ROTATE)) {
                    triggerIcon.bemAddModifier(MODIFIER_ROTATE);
                }
            });

            storageData.is_filtered_view = 0;
            this.updateLocalStorageData(storageData);
        },

        applyFilters: function () {
            var compareList = BEM.block('compare-list'),
                checkboxes = compareList.getElements('checkbox-filter'),
                sections = compareList.getElements('row-attributes-parent'),
                storageData = this.getLocalStorageData(),
                self = this;

            checkboxes.each(function (index, element) {
                var box = $(element);
                if (!box.is(':checked')) {
                    var row = box.closest('tr');
                    self.hideRow(row);
                }
            });

            sections.each(function (index, element) {
                var section = $(element);
                var childRows = $('tr[data-section-parent="' + section.data('section-identifier') + '"]');

                var allChildsHidden = true;
                childRows.each(function (index, row) {
                    var childRow = $(row);
                    if (childRow.css('display') !== 'none') {
                        allChildsHidden = false;
                        return false;
                    }
                });

                var triggerIcon = section.find('.' + BEM.buildElementClassname('compare-list', 'section-trigger-icon'));
                if (allChildsHidden) {
                    if (triggerIcon.bemHasModifier(MODIFIER_ROTATE)) {
                        triggerIcon.bemRemoveModifier(MODIFIER_ROTATE);
                    }
                } else {
                    if (!triggerIcon.bemHasModifier(MODIFIER_ROTATE)) {
                        triggerIcon.bemAddModifier(MODIFIER_ROTATE);
                    }
                }
            });

            storageData.is_filtered_view = 1;
            this.updateLocalStorageData(storageData);
        },

        restoreFilterStates: function () {
            var storageData = this.getLocalStorageData(),
                isFilteredView = storageData && storageData.is_filtered_view || null,
                filterAttributes = storageData && storageData.filter_attributes || null;

            if (filterAttributes) {
                $.each(filterAttributes, function (index, attribute) {
                    var checkbox = $('input[data-attribute="' + attribute + '"');
                    if (checkbox) {
                        checkbox.prop('checked', true);
                    }
                });
                if (isFilteredView) {
                    $('#radio-view-filtered').prop('checked', true).trigger('change');
                }
            }
        },

        onAttributeParentSectionTrigger: function (e) {
            if (this.isFilteredView) {
                return;
            }

            var section = $(e.currentTarget),
                childRows = $('tr[data-section-parent="' + section.data('section-identifier') + '"]'),
                self = this;

            childRows.each(function (index, element) {
                var row = $(element);
                if (row.css('display') !== 'none') {
                    self.hideRow(row);
                } else {
                    self.showRow(row);
                    section.css('box-shadow', '-16px 14px 12px -20px rgb(0 0 0)');
                }
            });

            var triggerIcon = section.find('i[data-section-parent="' + section.data('section-identifier') + '"]');

            if (triggerIcon.bemHasModifier(MODIFIER_ROTATE)) {
                triggerIcon.bemRemoveModifier(MODIFIER_ROTATE);
            } else {
                triggerIcon.bemAddModifier(MODIFIER_ROTATE);
            }
        },

        onClickCheckboxFilter: function (e) {
            var checkbox = $(e.currentTarget),
                storageData = this.getLocalStorageData(),
                attributeName = checkbox.data('attribute'),
                filters = storageData.filter_attributes || [];

            if (!filters.includes(attributeName)) {
                filters.push(attributeName);
            } else {
                filters.splice(filters.indexOf(attributeName), 1);
                if (this.isFilteredView) {
                    var row = checkbox.closest('tr');
                    this.hideRow(row);
                }
            }

            storageData.filter_attributes = filters;
            this.updateLocalStorageData(storageData);
        },

        onClickCloseButton: function (e) {
            this.exitLightbox();
        },

        productChooserCloseCallback: function () {
            if (this.itemCountBeforeChooser !== this.getLocalStorageData('item_count')) {
                this.refreshCompareTable();
            }
        },

        refreshCompareTable: function () {
            this.compareUrl = this.getCompareUrl();

            this._sendAjaxRequest(this.compareUrl, null, null, _.bind(function (response, status, xhr) {
                $('.' + BEM.buildElementClassname('compare-list', 'main-container')).replaceWith(response.result);
                this.refreshWindowUrl();
                this.initWrapperSideScrollEvents();
                this.initWrapperDownScrollEvents();
                this.restoreFilterStates();
                this.itemCountBeforeChooser = this.getLocalStorageData('item_count');
            }, this));
        },

        refreshWindowUrl: function() {
            var compareUrl = this.getCompareUrl();
            if (history.pushState) {
                window.history.pushState({ path: compareUrl }, '', compareUrl);
            }
        },

        onOverlayBackToTop: function (e) {
            e.preventDefault();
            $('#compare-list-overlay')[0].scrollIntoView();
        },

        openCatalogProductViewLightbox: function (detailViewUrl) {
            this._sendAjaxRequest(detailViewUrl, null, null, _.bind(function (response, status, xhr) {

                var responseHandles = $.parseJSON(xhr.getResponseHeader('X-Magento-Handles') || '[]');

                if (responseHandles.indexOf('gigaset_dealerpos_checkout_productview') > -1 &&
                    responseHandles.indexOf('catalog_product_view') < 0
                ) {
                    responseHandles.push('catalog_product_view');
                }

                if (responseHandles.indexOf('catalog_product_customoption_print') > -1) {
                    responseHandles.splice(responseHandles.indexOf('catalog_product_customoption_print'), 1);
                }

                this.renderMagnificPopup(response, _.bind(this.applyProductViewLightboxStyles, this), null,true, responseHandles);
            }, this));
        },

        openProductChooserPopup: function () {
            var productChooserCta = this.compareListHeaderSidebar.getElements('cta-product-chooser'),
                url = productChooserCta.data('product-chooser-url');

            let data = { attributeSet: this.getLocalStorageData('attribute_set'), productIds: this.getLocalStorageData('product_ids') };

            this._sendAjaxRequest(url, data, null, _.bind(function (response, status, xhr) {

                this.renderMagnificPopup(response, _.bind(this.initializeProductChooser, this), _.bind(this.productChooserCloseCallback, this), null, null);

            }, this));
        },

        /**
         * Send ajax request
         *
         * @param url
         * @param data
         * @param callback
         * @param onSuccessCallback
         * @private
         */
        _sendAjaxRequest: function (url, data, callback, onSuccessCallback) {
            var self = this;
            data = data || {};

            Spinner.add($document);

            // add isAjax param to avoid caching problems
            if (url.indexOf('isAjax=1') === -1 && typeof data === 'string' && data.indexOf('isAjax=1') === -1) {
                url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
            }

            url = (this.isSecure === true && url.indexOf('http://') === 0) ? url.replace('http://', 'https://') : url;

            $.ajax(url, {
                method: 'POST',
                data: data
            }).then(_.bind(function (response, status, xhr) {

                if (typeof callback === 'function') {
                    callback(response, status, xhr);
                }

                Spinner.remove();

                if ((response.error || response.success === false)) {
                    self.renderMagnificPopup(response.error);
                } else {
                    if (typeof onSuccessCallback === 'function') {
                        onSuccessCallback(response, status, xhr);
                    }
                }
            }, this));
        },

        renderMagnificPopup: function (message, onOpenCallback, onCloseCallback, configurableOptions, responseHandles) {
            configurableOptions = configurableOptions || false;
            responseHandles = responseHandles || [];

            var self = this;

            var newModalMainClasses = (responseHandles.indexOf('catalog_product_view') > -1) ?
                ['container-size', 'shadow', 'mfp-product-view', 'b_compare-popup-product-details'] :
                ['shadow'];

            if ($.magnificPopup.instance.isOpen) {
                if (self.modalMainClasses) {
                    _.forEach(self.modalMainClasses, function (className) {
                        $.magnificPopup.instance.wrap.removeClass(className);
                        $.magnificPopup.instance.bgOverlay.removeClass(className);
                    });
                }
                _.forEach(newModalMainClasses, function (className) {
                    $.magnificPopup.instance.wrap.addClass(className);
                    $.magnificPopup.instance.bgOverlay.addClass(className);
                });
            }

            self.modalMainClasses = newModalMainClasses;

            $.magnificPopup.open({
                mainClass: self.modalMainClasses.join(' '),
                items: {
                    src: this._renderPopup({
                        body: message,
                    }),
                    type: 'inline',
                },
                closeBtnInside: true,
                callbacks: {
                    open: function () {

                        if (typeof onOpenCallback === 'function') {
                            onOpenCallback();
                        }

                        if (configurableOptions) {
                            new ComponentDispatcher({
                                handles: ['catalog_product_view', 'PRODUCT_TYPE_configurable'],
                                apply: Handles
                            });
                        }

                        if (typeof onCloseCallback === 'function') {
                            $.magnificPopup.instance.close = function() {
                                onCloseCallback();
                                // Call the original close method to close the popup
                                $.magnificPopup.proto.close.call(this);
                            };
                        }
                    }
                }
            });
        },

        _renderPopup: function (data) {
            if (null === popupTemplate) {
                popupTemplate = _.template(PopupHtml);
            }

            return popupTemplate(data);
        },

        applyProductViewLightboxStyles: function () {
            var viewBlock = BEM.block('product-view');

            if (this.isCategoryPage && viewBlock.length) {
                var popup = $('.popup-body'),
                    compareLink = $('.compare-link', popup);

                $('.tooltip').hide();

                compareLink.insertAfter(viewBlock.getElements('column-top').first());
                compareLink.addClass('btn btn-outline');
                compareLink.wrap('<div class="compare-link-container"></div>');

                var closeBtn = '<div class="cta-close-container"><div class="cta-close btn" ' +
                    'data-toggle="tooltip" title="%s">×</div></div>'.replace('%s', Translator.translate('Close'));

                popup.prepend(closeBtn);
                $document.on('click', '.cta-close', _.bind(this.exitLightbox, this));
            }
        },

        updateLocalStorageData: function (data) {
            var storageData = this.localStorage.getItem(this.config.storage.identifier);
            if (data && Object.keys(data).length) {
                if (!storageData) {
                    storageData = {};
                } else {
                    storageData = JSON.parse(storageData);
                }
                storageData[this.storeCode] = data;
                this.localStorage.setItem(this.config.storage.identifier, JSON.stringify(storageData));
            }
        },

        getLocalStorageData: function (key) {
            var storageData = this.localStorage.getItem(this.config.storage.identifier);

            if (!storageData || storageData === 'undefined') {
                return null;
            }

            storageData = JSON.parse(storageData);

            if (!storageData[this.storeCode]) return null;

            storageData = storageData[this.storeCode];

            return key ? storageData[key] : storageData;
        },

        resetLocalStorageData: function () {
            var storageData = this.localStorage.getItem(this.config.storage.identifier);
            storageData = JSON.parse(storageData);

            if (storageData && storageData[this.storeCode]) {
                delete storageData[this.storeCode];
                this.localStorage.setItem(this.config.storage.identifier, JSON.stringify(storageData));
            }
        },

        initLocalStorage: function () {
            var keyWhitelist = this.config.storage.key_whitelist,
                data = $('.' + BEM.buildElementClassname('compare-list', 'container')).data('compare-list-init');

            var storageUpdate = {};

            $.each(data, function (key, value) {
                var result = null;
                if (keyWhitelist.includes(key)) {
                    if (key === 'product_ids' || key === 'filter_attributes') {
                        result = [];
                        if (key === 'product_ids') {
                            result = value.split(',').map(Number);
                        }
                        if (key === 'filter_attributes') {
                            result = value.split(',');
                        }
                    } else {
                        if (key === 'item_count' || key === 'attribute_set' || key === 'is_filtered_view') {
                            result = Number(value);
                        } else {
                            result = value;
                        }
                    }

                    storageUpdate[key] = result;
                }
            });

            if (Object.keys(storageUpdate).length) {
                this.updateLocalStorageData(storageUpdate);
            }
        },

        toggleOverlay: function () {
            var storageData = this.getLocalStorageData(),
                overlay = BEM.block('compare-overlay');

            if (overlay) {
                this.overlay = overlay;

                if (!storageData || !storageData.item_count || storageData.item_count < 1 || this.isCheckoutPage || this.isComparisonPage) {
                    this.hideOverlay();
                } else {
                    this.showOverlay();
                }

                $document.on('click', '.' + BEM.buildElementClassname('compare-overlay', 'compare-button'), _.bind(function (e) {
                    var button = $(e.currentTarget);
                    button.prop('href', this.getCompareUrl());
                    button.prop('target', '_blank');
                    button.prop('rel', 'noreferer noopener');
                }, this));
            }
        },

        hideOverlay: function () {
            if (this.overlay.length) {
                var compareButton = this.overlay.getElements('compare-button');

                if (this.overlay.hasClass('slideIn')) {
                    this.overlay.removeClass('slideIn').addClass('slideOut');
                }
                if (!compareButton.hasClass('disabled')) {
                    compareButton.addClass('disabled');
                }
            }
        },

        showOverlay: function () {
            var compareButton = this.overlay.getElements('compare-button');

            if (this.overlay.hasClass('slideOut')) {
                this.overlay.removeClass('slideOut').addClass('slideIn');
            }
            if (compareButton.hasClass('disabled')) {
                compareButton.removeClass('disabled');
            }
        },

        getCompareUrl: function () {
            var compareButton = BEM.block('compare-overlay').getElements('compare-button'),
                storageData = this.getLocalStorageData();

            if (storageData) {
                var searchParams = new URLSearchParams(this.getLocalStorageData()).toString();
                return new URL(compareButton.data('base-url')) + '?' + btoa(searchParams);
            } else {
                return compareButton.data('base-url');
            }
        },

        showRow: function (row) {
            if (row.bemHasModifier('hide')) {
                row.bemRemoveModifier('hide');
            }
            if (row.hasClass('hidden-print')) {
                row.removeClass('hidden-print');
            }
        },

        hideRow: function (row) {
            if (!row.hasClass('hidden-print')) {
                row.addClass('hidden-print');
            }
            if (!row.bemHasModifier('hide')) {
                row.bemAddModifier('hide');
            }
        },

        fixStickyRowDimensions: function () {
            var rowSticky = $('.' + BEM.buildElementClassname('compare-list', 'row-sticky')),
                cloneRow = $('.' + BEM.buildElementClassname('compare-list', 'row-attributes-child')).first();

            if (cloneRow.length) {
                rowSticky.css('width', cloneRow.css('width'));
                rowSticky.find('th').css('width', cloneRow.find('th').first().css('width'));
                rowSticky.find('td').css('width', cloneRow.find('td').first().css('width'));
            }
        },

        isMobileDevice: function () {
            return window.matchMedia('only screen and (max-width: 480px)').matches;
        },

        triggerSessionMessage: function (txt, type, fadeSeconds = null) {
            const html = '<ul class="messages"><li class="' + type + '-msg"><ul><li><span>' + txt + '</span></li></ul></li></ul>';

            BEM.block('product-view').getElements('container').first().prepend(html);

            const messageBlock = $('ul.messages:first');
            messageBlock.css('margin-top', '10px').css('margin-bottom', '30px');

            setTimeout(function () {
                messageBlock.fadeOut('slow').remove();
            }, fadeSeconds || 15000);
        },

        initWrapperDownScrollEvents: function () {
            this.fixStickyRowDimensions();

            $(window).on('scroll', function () {
                var rowSticky = $('.' + BEM.buildElementClassname('compare-list', 'row-sticky'));

                if (rowSticky.length) {
                    if (!self.stickyRowOffsetTop) {
                        self.stickyRowOffsetTop = rowSticky.offset().top;
                    }
                    var windowTop = $(window).scrollTop();
                    if (self.stickyRowOffsetTop < windowTop) {
                        if (!rowSticky.bemHasModifier('sticky')) {
                            rowSticky.bemAddModifier('sticky');
                        }
                    } else {
                        if (rowSticky.bemHasModifier('sticky')) {
                            rowSticky.bemRemoveModifier('sticky');
                        }
                    }
                }
            });
        },

        initWrapperSideScrollEvents: function () {
            var wrapper = $('.' + BEM.buildElementClassname('compare-list', 'wrapper')),
                wrapperHeader = $('.' + BEM.buildElementClassname('compare-list', 'wrapper--header')),
                wrapperContent = $('.' + BEM.buildElementClassname('compare-list', 'wrapper--content')),
                wrapperHeaderSticky = $('.' + BEM.buildElementClassname('compare-list', 'row-sticky')),
                running = false;

            wrapperHeader.on('scroll', function () {
                if (running) {
                    running = false;
                    return;
                }
                running = true;
                wrapperContent.scrollLeft(wrapperHeader.scrollLeft());
                wrapperHeaderSticky.css({marginLeft: -1 * wrapperHeader.scrollLeft()});
                // wrapperHeaderSticky.scrollLeft(wrapperHeader.scrollLeft());
            });
            wrapperContent.on('scroll', function () {
                if (running) {
                    running = false;
                    return;
                }
                running = true;
                wrapperHeader.scrollLeft(wrapperContent.scrollLeft());
                wrapperHeaderSticky.css({marginLeft: -1 * wrapperContent.scrollLeft()});
                // wrapperHeaderSticky.scrollLeft(wrapperContent.scrollLeft());
            });

            let pos = {top: 0, left: 0, x: 0, y: 0};
            var actualTarget = null;

            const compareWrapperMouseMoveHandler = function (e) {
                var target = $(actualTarget);
                const dx = e.clientX - pos.x;
                target.scrollLeft(pos.left - dx);
                // const dy = e.clientY - pos.y;
                // wrapper.scrollTop(pos.top - dy);
            };

            const compareWrapperMouseUpHandler = function () {
                var target = $(actualTarget);
                target.css('cursor', 'grab');
                target.removeProp('user-select');

                $document.off('mousemove', compareWrapperMouseMoveHandler);
                $document.off('mouseup', compareWrapperMouseUpHandler);
            };

            const compareWrapperMouseDownHandler = function (e) {
                var target = $(e.currentTarget);
                target.css('cursor', 'grabbing');
                target.css('userSelect', 'none');

                pos = {
                    left: target.scrollLeft(),
                    top: target.scrollTop(),
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                actualTarget = e.currentTarget;

                $document.on('mousemove', compareWrapperMouseMoveHandler);
                $document.on('mouseup', compareWrapperMouseUpHandler);
            };

            wrapper.on('mousedown', compareWrapperMouseDownHandler);
        }
    });
});

